import { adaptOptions } from '~/services/origins/contentful/adapters/adaptOptions';
import { ComponentType } from '~/shared/domain/models';
import type { ContentfulFieldSelect } from '~/services/origins/contentful';
import type { FieldSelectSchema } from '~/shared/domain/models';

export const adaptFieldSelect = (field: ContentfulFieldSelect): FieldSelectSchema => {
  if (!field?.fields) {
    throw new Error('Missing field select params');
  }

  const { fields } = field;

  return {
    componentType: ComponentType.FieldSelect,
    label: fields.label,
    name: fields.name,
    defaultValue: fields.defaultValue?.fields.value,
    disabled: fields.disabled,
    options: adaptOptions(fields.options),
    validations: {
      required: fields.required,
    },
    messages: {
      error: fields.errorMessage,
      helperText: fields.helperMessage,
    },
  };
};
